/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mean_Long_Rooster_SwimInputs */

const en_mean_long_rooster_swim = /** @type {(inputs: Mean_Long_Rooster_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select segments`)
};

const de_mean_long_rooster_swim = /** @type {(inputs: Mean_Long_Rooster_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente auswählen`)
};

/**
* | output |
* | --- |
* | "Select segments" |
*
* @param {Mean_Long_Rooster_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mean_long_rooster_swim = /** @type {((inputs?: Mean_Long_Rooster_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mean_Long_Rooster_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mean_long_rooster_swim(inputs)
	return de_mean_long_rooster_swim(inputs)
});